// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__7zA3D","label":"Section_label__37TCW","contentWrap":"Section_contentWrap__emE4O","footer":"Section_footer__1ynFV","footerInner":"Section_footerInner__-oOYu"};